import { UIKitIcon } from '../icon';

export const starIcon: UIKitIcon = {
  name: 'star',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><polygon points="16 6.49 19.09 12.75 26 13.76 21 18.63 22.18 25.51 '
  + '16 22.26 9.82 25.51 11 18.63 6 13.76 12.91 12.75 16 6.49" style="fill:inherit;stroke:inherit;stroke-linecap:round;stroke-linejoin:'
  + 'round"/></svg>',
};
